import React, {useContext, useEffect, useState} from "react";
import './MobileLink.css'
import './Animation.css'
import './mobileView.css'
import './thirdPage.css'
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import {Elink, FetchEstimateDetailRecordsUrl} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import {Animation} from "./Animation";
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

export default () => { // This component render the mobile link start page
    let PageView = useContext(ViewMangementContext);
    let RecordsController = useContext(RecordsManagementContext);
    let JobIsOpen = RecordsController.IsCustomerEditEstAftrBook;
    let CustomerInvReq = RecordsController.ML_Start.CustomerInventoryRequest;

    useEffect(()=>{
        if(RecordsController.Click){
            Animation("start-page",RecordsController.Click); // add animate class
        }
        if (RecordsController.ML_Start.LastPageVisited) { // if customer last visited present then fetch details
            axios({// sending post request
                method: 'post',
                url: FetchEstimateDetailRecordsUrl,
                params: {estimate_key: Elink}
            }).then((response) => {
                RecordsController.SetML_Start(response.data);
                RecordsController.setOtherBedrooms(response.data.BedroomCount)
            });
        }
    },[])

    const ShowFirstStep = () => { // render next step
        RecordsController.SetClick('next');
        AnimationPrevious ( "next-go",  "start-page", "SHOW_MOBILE_LINK_BEDROOM", PageView);
    }

    const FirstPageContent = (device_type) => { // render page content
        return(
            <>
                <Modal className="alert-modal" show={!JobIsOpen || RecordsController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordsController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordsController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                            "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center h-100" id="first-page-content">
                        <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5">
                            <div className="card-st text-center">
                                <div className={device_type === "mobile-vw" ? "logo-image p-3 text-center" :
                                    "logo-image-desktop  text-center" } >
                                    <img src={RecordsController.ML_Start.CompanyLogo ? RecordsController.ML_Start.CompanyLogo :
                                        process.env.PUBLIC_URL + "/Images/mobileLinkLogo.png"} alt="image" style={{margin: "0rem!important"}}/>
                                    <br/>
                                </div>
                                <div className="text-first-page " style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>
                                    {CustomerInvReq.EditVerbiage.default === "false" ? <b>{CustomerInvReq.EditVerbiage.initial_page_heading}</b> : <b>Let’s add your inventory</b> }
                                    {CustomerInvReq.EditVerbiage.default === "false" ? <p className="text-first-page-white ">{CustomerInvReq.EditVerbiage.initial_page_subtitle}</p> :
                                        <p className="text-first-page-white" style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>This helps us got the most accurate estimate possible.</p>}
                                </div>
                                <div className={device_type === "mobile-vw" ? "img-s2" : "d-image" }
                                     style={device_type === "mobile-vw" ?{position:"relative"} : {}}>
                                    <img id={device_type === "mobile-vw" ? "start-img2" : "start-Delivery-image"}
                                         style={device_type === "mobile-vw" ?{zIndex: "-1"} : {backgroundColor: CustomerInvReq.BackgroundColor}}
                                         src={CustomerInvReq.ImageUrl !== "default_image" && CustomerInvReq.ImageUrl !== "" ? CustomerInvReq.ImageUrl : process.env.PUBLIC_URL + "/Images/mobileLinkDelivery.png" } alt="image"/>
                                </div>
                            </div>
                        </div>
                        <button className="btn btn-st start-page desktop-vw" style={{position:"absolute", backgroundColor: CustomerInvReq.ButtonColor}}
                                 type="submit" onClick={() => ShowFirstStep()}><b style={{color: GetTextColor(CustomerInvReq.ButtonColor)}}>NEXT</b>&nbsp;
                            <i className="fas fa-arrow-right" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.ButtonColor)}}></i></button>
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <section className="gradient-custom desktop-vw" style={{background: CustomerInvReq.BackgroundColor}} >
                <div className={"start-page h-100"} style={{width: "100vw"}}>
                    {FirstPageContent("desktop-vw")}
                </div>
            </section>
            <section className="mobile-section mobile-vw" style={{background: CustomerInvReq.BackgroundColor}}>
                <div className={"start-page h-75"} style={{width: "100vw", height: "75%!important"}}>
                    <svg id="curve" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1416.99 174.01">
                        <path className="curve-path" d="M0,280.8S283.66,59,608.94,163.56s437.93,150.57,808,10.34V309.54H0V280.8Z"
                              transform="translate(0-135.53)" style={{position:"relative"}} fill="#f2f5f8"/>
                        <path className="curve-path"
                              d="M77.8,230.3S283.66,353,880.94,275.58s937.93,190.57,920,10.34V309.54H0V280.8Z"
                              transform="translate(0-135.53)" style={{position:"relative"}} fill="white"/>
                    </svg>
                    {FirstPageContent("mobile-vw")}
                </div>
            </section>
            <div className="mobile-vw h-25" >
                <div id="second-div start-page" style={{paddingTop: "8%"}}>
                    <button className="btn btn-st start-mobile-view mobile-vw" type="submit"
                            style={{position:"relative", width: "80%", marginBottom: "1%", backgroundColor: CustomerInvReq.ButtonColor,color: GetTextColor(CustomerInvReq.ButtonColor)}} onClick={() => ShowFirstStep()} >
                        <b>NEXT</b>&nbsp;<i className="fas fa-arrow-right" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </>
    )
}

